<template>
	<div>
		<label class="pre-inline">{{pre_item.name}}:</label>
		<el-date-picker v-model="pre_item.val" type="month" :class="[pre_item.class==''?'short0':pre_item.class]"
			value-format="yyyy-MM" placeholder="选择月份" @change="val_back">
		</el-date-picker>
		<em v-show="pre_item.w=='1'">*</em><em v-show="pre_item.w=='0'"></em>
	</div>
</template>

<script>
	//

	// import {
	//   dateFormatbyChina
	// } from '@/utils/method.js';

	export default {
		name: "hj-datemonth",
		data() {
			return {
				pre_item: {},
				is_active: false,

				sel_month: ''
			}
		},
		props: {
			inData: {
				type: String,
				default: ''
			}
		},
		watch: {
			inData(val) {
				// console.log('检测=',val);
				if (typeof(val) !== 'undefined' && val != '') {
					this.pre_item = {};
					this.pre_item = JSON.parse(val);
				}
			}
		},
		created() {
			// console.log('hj-datemonth 组件创建时调用 创建');
			this.init();
		},
		activated: function() {
			// console.log('hj-datemonth 组件激活时调用 激活');
			this.init();
		},
		deactivated: function() {
			// console.log('hj-date 组件激活时调用 停用');
			this.pre_item = {};
			this.is_active = false;
		},
		methods: {
			init: function() {
				// console.log('初始化=',this.inData);
				if (!this.is_active) {
					this.pre_item = {};
					this.pre_item = JSON.parse(this.inData);
					this.is_active = true;
				}
			},
			val_back: function() {
				// console.log(this.pre_item.val);
				// let temp='';

				// temp=dateFormatbyChina(this.pre_item.val);
				// this.pre_item.val=temp;
				// this.sel_month='';
				// this.pre_item.val
				this.$emit('com-event', this.pre_item);
			}
		}
	}
</script>

<style scoped="scoped">
	.pre-date {
		display: flex;
		align-items: center;
	}
	
	.pre-inline {
		display: inline-block;
		vertical-align: middle;
		margin-right: 2px;
		min-width: 108px;
	}
	
	.pre-em {
		display: inline-block;
		vertical-align: middle;
		width: 10px;
	}
	
	.pre-inline {
		display: inline-flex;
		vertical-align: bottom;
		align-items: center;
		justify-content: flex-end;
		height: 32px;
	}
</style>
